export { default } from "./Locator";
